import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

const AdminTasksEndpoints = {
  escalateTask: (taskId: number) => `/tasks/${taskId}/escalate`,
}

export const useEscalateTask = () => {
  return useMutation<void, Error, number>({
    mutationFn: async (taskId: number) => {
      const response = await axios.post(
        AdminTasksEndpoints.escalateTask(taskId)
      )
      return response.data
    },
  })
}
